module.exports = __webpack_public_path__ + "3be4e11baebad06e638d0c23d26556a1.MP3";